import constants from '../constants';

export const hasEmoji = navigator.userAgent.indexOf('Windows') === -1;

export const canShare = navigator.share && navigator.canShare;

export const isIOSorSafari =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export function buildShareString(team, shareApi) {
  let str = 'Minha avaliação de elenco \n*';
  str += `${team.name} no Brasileirão 2025`;

  constants.evalOrder.forEach((val) => {
    const filtered = [...team.athletes]
      .sort((a, b) => a.name.localeCompare(b.name))
      .filter((item) => item.eval === val);
    const goodToGo = filtered.length > 0;
    const label = constants.eval[val];

    if (goodToGo) {
      str += `\n\n${label.emoji} _${label.title}_ `;
      filtered.forEach((athlete) => {
        str += `\n${athlete.name} - ${athlete.position.field} `;
      });
    }
  });

  if (!canShare || isIOSorSafari)
    str += `\n\nFaça a sua em ${constants.share.url}`;

  return str;
}
